module.exports = __webpack_public_path__ + "static/media/MaisonNeue-MediumItalic.38a3c03b.ttf";